import store from '@/store';

// 搜索时间下拉框，快捷键
const pickerTime = {
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "开始时间",
      onClick() {
        store.state.changeDate = 1;
      }
    },
    {
      text: "结束时间",
      onClick() {
        store.state.changeDate = 2;
      }
    }
  ],
  disabledDate(time) { // 禁用日期设置
    let current_time = new Date().Format('yyyy-MM-dd') + ' 23:59:59';  //时间日期为：‘当前日期 23:59:59’
    let t = new Date(current_time).getTime(); //‘当前日期 23:59:59’的时间戳
    return time.getTime() > t;
  }
}

const pickerDate = {
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "开始时间",
      onClick() {
        store.state.changeDate = 1;
      }
    },
    {
      text: "结束时间",
      onClick() {
        store.state.changeDate = 2;
      }
    }
  ],
  disabledDate(time) { // 禁用日期设置
    let times = Date.now() - 24 * 60 * 60 * 1000;
    let current_time = new Date(times).Format('yyyy-MM-dd') + ' 23:59:59';  //时间日期为：‘当前日期 23:59:59’
    let t = new Date(current_time).getTime(); //‘当前日期 23:59:59’的时间戳
    return time.getTime() > t;
  }
}

const pickerOptions = {
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
        store.state.changeDate = 0;
      }
    },
    {
      text: "开始时间",
      onClick() {
        store.state.changeDate = 1;
      }
    },
    {
      text: "结束时间",
      onClick() {
        store.state.changeDate = 2;
      }
    }
  ],
  disabledDate(time) { // 禁用日期设置
    let current_time = new Date().Format('yyyy-MM-dd') + ' 23:59:59';
    let times = new Date(current_time).getTime() - 2 * 1000 * 24 * 60 * 60;
    return time.getTime() > times;
  }
}

export default {
  pickerTime,
  pickerDate,
  pickerOptions,
}


// WEBPACK FOOTER //
// ./src/utils/pageComAction.js